import React, { useEffect, useRef, useState } from "react";
import ChecklistForm from "../../forms/ChecklistForm";
import { FormattedMessage } from "react-intl";
import { Button } from "sr/helpers/ui-components/company/Button";
import { Checkbox } from "sr/helpers/ui-components/CheckBox";
import TaskForm from "../../forms/TaskForm";
import { AllChecklist } from "../../../ChecklistTemplate/AllChecklist";
import { Task } from "../../Tables/Task";
import { useParams } from "react-router-dom";
import { createTasklists } from "sr/utils/api/company/customer/createTasklists";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { updateChecklist } from "sr/utils/api/company/customer/updateChecklist";

export const AddChecklist = (props) => {
  const [GlobalTemplate, setGlobalTemplate] = useState(false);
  const [copyTasks, setCopyTasks] = useState([]);
  const [existingTasks, setExistingTasks] = useState([]);
  const [addMore, setAddMore] = useState(false);
  const [model, setModel] = useState(false);
  const [checklistId, setchecklistId] = useState(null);
  const [taskadded, setTaskAdded] = useState(0);
  const [companyId, setCompanyId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [loader, setLoader] = useState(false);
  const params = useParams();
  useEffect(() => {
    const { id, checklistId, instruction } = params;
    setchecklistId(checklistId || instruction);
    setCustomerId(id);
  }, [params]);
  useEffect(() => {
    const userData = getUserDetails();
    setCompanyId(userData?.user_id);
  }, []);

  interface TabRef {
    submitForm: () => void;
  }
  const [modelChecklistAdded, setModelChecklistAdded] = useState(false);
  const childRef = useRef<TabRef>(null);
  const HandleFormSubmit = () => {
    if (childRef.current && childRef.current.submitForm) {
      childRef.current.submitForm();
    }
  };
  const dataAddedHandle = (data) => {
    if (data === "Checklist") {
      setModelChecklistAdded(true);
    }
    if (data === "Task") {
      setTaskAdded(taskadded + 1);
      setAddMore(false);
    }
  };
  const ChecklistHandle = async (tasks) => {
    setLoader(true);

    // Filter out tasks that already exist on this checklist by name
    const newTasks = tasks.filter(
      (t) =>
        !existingTasks.some(
          (existing) =>
            existing.name.trim().toLowerCase() === t.name.trim().toLowerCase(),
        ),
    );

    if (newTasks.length === 0) {
      setLoader(false);
      return;
    }

    const formData = [];
    for (let i = 0; i < newTasks?.length; i++) {
      const data = {
        company_id: companyId,
        customer_id: customerId,
        checklist_id: checklistId,
        name: newTasks[i]?.name,
        type: newTasks[i]?.type,
        description: newTasks[i]?.description,
        status: "active",
        position: existingTasks.length + i + 1, // continue after existing positions
      };
      formData.push(data);
    }

    setCopyTasks(newTasks);

    try {
      const res = await createTasklists(formData);
      if (res.success === true) {
        const cPayload = {
          id: checklistId,
          status: "active",
        };
        const cres = await updateChecklist(cPayload);
        if (cres?.success === true) {
          setTaskAdded(taskadded + 1);
          setLoader(false);
        }
      } else {
        setLoader(false);
      }
    } catch (e) {
      setLoader(false);
    }
  };
  const saveTaskHandle = () => {
    if (childRef.current && childRef.current.submitForm) {
      childRef.current.submitForm();
    }
  };
  return (
    <>
      {!modelChecklistAdded ? (
        <>
          <ChecklistForm
            ref={childRef}
            dataAddedHandle={dataAddedHandle}
            customer_Id={props?.customer_Id}
          />
          <Button
            text={
              <FormattedMessage
                id={
                  checklistId
                    ? "RECRUITER.CUSTOMER.CHECKLIST.ADD.TASKS.BUTTON"
                    : "RECRUITER.CUSTOMER.CHECKLIST.SAVE.BUTTON"
                }
                defaultMessage={checklistId ? "Add Tasks" : "Add Checklist"}
              />
            }
            onClick={HandleFormSubmit}
          ></Button>
        </>
      ) : (
        <>
          {/* Show import option for fresh (non-edit) flow with no copied tasks */}
          {!props?.isEditCheckList && copyTasks.length === 0 && (
            <div className="mt-5">
              <div className="flex items-center gap-1">
                <Checkbox
                  id="Global"
                  label={
                    <FormattedMessage
                      id="RECRUITER.CUSTOMER.CHECKLIST.GLOBAL.TITLE"
                      defaultMessage="Import from Global Checklist"
                    />
                  }
                  onChange={() => setGlobalTemplate(!GlobalTemplate)}
                  value={GlobalTemplate}
                />
                <div className="group relative flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="size-4 cursor-pointer text-gray-500"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <div className="absolute left-0 top-6 z-20 w-64 scale-0 rounded bg-gray-800 p-3 text-xs text-white shadow-lg transition-transform duration-150 group-hover:scale-100">
                    <FormattedMessage
                      id="RECRUITER.CUSTOMER.CHECKLIST.GLOBAL.DESCRIPTION"
                      defaultMessage="Global Checklists are preloaded general cleaning task lists."
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Show import option in edit mode when existing tasks are loaded from backend */}
          {props?.isEditCheckList && existingTasks.length > 0 && (
            <div className="mt-5">
              <div className="flex items-center gap-1">
                <Checkbox
                  id="Global"
                  label={
                    <FormattedMessage
                      id="RECRUITER.CUSTOMER.CHECKLIST.GLOBAL.TITLE"
                      defaultMessage="Import from Global Checklist"
                    />
                  }
                  onChange={() => setGlobalTemplate(!GlobalTemplate)}
                  value={GlobalTemplate}
                />
                <div className="group relative flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="size-4 cursor-pointer text-gray-500"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <div className="absolute left-0 top-6 z-20 w-64 scale-0 rounded bg-gray-800 p-3 text-xs text-white shadow-lg transition-transform duration-150 group-hover:scale-100">
                    <FormattedMessage
                      id="RECRUITER.CUSTOMER.CHECKLIST.GLOBAL.DESCRIPTION"
                      defaultMessage="Global Checklists are preloaded general cleaning task lists."
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Task form for non-edit flow */}
          {!props?.isEditCheckList && !GlobalTemplate && (
            <>
              <TaskForm ref={childRef} dataAddedHandle={dataAddedHandle} />
              <Button
                text={
                  <FormattedMessage
                    id="RECRUITER.CUSTOMER.CHECKLIST.SAVE.TASK_BUTTON"
                    defaultMessage="Save Task"
                  />
                }
                onClick={HandleFormSubmit}
              ></Button>
            </>
          )}
        </>
      )}

      {!props?.isEditCheckList && GlobalTemplate && copyTasks.length === 0 ? (
        <AllChecklist ChecklistHandle={ChecklistHandle} />
      ) : null}

      {/* Show AllChecklist in edit mode too when global template is selected */}
      {props?.isEditCheckList && GlobalTemplate && (
        <AllChecklist ChecklistHandle={ChecklistHandle} />
      )}

      {modelChecklistAdded && (
        <ContentWithSpinner loader={loader}>
          <div className="overflow-x-auto mt-10 rounded-[20px] border border-neutral-200">
            <Task
              onClick={() => setModel(true)}
              taskadded={taskadded}
              getTasks={(t) => setExistingTasks(t)}
            />
          </div>
        </ContentWithSpinner>
      )}

      {/* Show Task table in edit mode (modelChecklistAdded may be false on fresh session) */}
      {props?.isEditCheckList && !modelChecklistAdded && (
        <ContentWithSpinner loader={loader}>
          <div className="overflow-x-auto mt-10 rounded-[20px] border border-neutral-200">
            <Task
              onClick={() => setModel(true)}
              taskadded={taskadded}
              getTasks={(t) => setExistingTasks(t)}
            />
          </div>
        </ContentWithSpinner>
      )}

      {addMore && <TaskForm ref={childRef} dataAddedHandle={dataAddedHandle} />}
      {((modelChecklistAdded && props?.isEditCheckList && addMore) ||
        (copyTasks?.length > 0 && addMore)) && (
        <Button
          onClick={saveTaskHandle}
          text={
            <FormattedMessage
              id="RECRUITER.CUSTOMER.CHECKLIST.SAVE.TASK.BUTTON"
              defaultMessage="Save Task"
            />
          }
        ></Button>
      )}
      {((modelChecklistAdded && props?.isEditCheckList && !addMore) ||
        (copyTasks?.length > 0 && !addMore)) && (
        <Button
          onClick={() => setAddMore(true)}
          text={
            <FormattedMessage
              id="RECRUITER.CUSTOMER.CHECKLIST.TASK.BUTTON"
              defaultMessage="Add More Task"
            />
          }
        ></Button>
      )}
    </>
  );
};
